import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";

const iconFor = (action) => {
  if (action.startsWith("document")) return "text-blue-600";
  if (action.startsWith("client")) return "text-slate-700";
  if (action.startsWith("contact")) return "text-slate-700";
  if (action.startsWith("message")) return "text-emerald-600";
  if (action.startsWith("flash")) return "text-purple-600";
  if (action === "login") return "text-amber-600";
  return "text-slate-500";
};

export default function Activity() {
  const [rows, setRows] = useState([]);
  useEffect(() => { (async () => { const r = await api.get("/activities?limit=500"); setRows(r.data); })(); }, []);

  return (
    <div className="space-y-6" data-testid="activity-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500">Audit</div>
        <h1 className="mt-1 font-[Manrope] font-extrabold text-4xl tracking-tight">Activity log</h1>
        <p className="mt-2 text-slate-600">Every action, reply, and flash dispatch — chronologically.</p>
      </div>
      <Card className="border border-slate-200 shadow-none rounded-md overflow-hidden">
        <div className="divide-y divide-slate-100 max-h-[75vh] overflow-y-auto">
          {rows.length === 0 && <div className="p-8 text-sm text-slate-500 text-center">No activity recorded yet.</div>}
          {rows.map(a => (
            <div key={a.id} className="px-5 py-3 flex items-start gap-4 hover:bg-slate-50 transition-colors" data-testid={`activity-${a.id}`}>
              <div className={`mt-1 h-2 w-2 rounded-full ${iconFor(a.action).replace("text-", "bg-")}`} />
              <div className="flex-1 min-w-0">
                <div className="text-sm">
                  <span className="font-semibold">{a.actor}</span>
                  <span className="text-slate-500"> · </span>
                  <span className="font-mono text-xs text-slate-700">{a.action}</span>
                  {a.target && <span className="ml-2 text-xs font-mono text-slate-500">{a.target}</span>}
                </div>
                {a.meta && Object.keys(a.meta).length > 0 && (
                  <div className="mt-1 text-xs text-slate-500 font-mono truncate">{JSON.stringify(a.meta)}</div>
                )}
              </div>
              <div className="text-[11px] font-mono text-slate-500 whitespace-nowrap">{new Date(a.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
